import React from 'react';
import styles from './ResponsiveTable.module.scss';

interface ResponsiveTableProps {
	className?: string;
	rows: { [key: string]: any }[]; // Each row is an object with column keys
	columns: string[]; // Array of column headers or keys
}

export default function ResponsiveTable({ className = '', rows = [], columns = [] }: ResponsiveTableProps) {
	if (rows.length === 0 || columns.length === 0) return null; // Return null if no data

	return (
		<div className={styles.tableContainer}>
			<div className={styles.tableResponsive}>
				<table className={styles.table}>
					<thead>
						<tr>
							{columns.map((column, index) => (
								<th key={index} className={styles.tableHeader}>
									{column}
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{rows.map((row, rowIndex) => (
							<tr
								key={rowIndex}
								className={`${styles.rowHover} ${rowIndex % 2 === 0 ? styles.evenRow : styles.oddRow}`}>
								{columns.map((column, colIndex) => (
									<td key={colIndex} className={styles.tableCell} data-label={column}>
										{column || '-'}
									</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}
